import { DynamicDCAComponentProvider } from '@marriott/mi-headless-utils';
import { MerchandisingHeroBanner as HeroBanner } from './organisms/MerchandisingHeroBanner';
import {
  MerchandisingSmallBanner as SmallBanner,
  MerchandisingSmallBannerComponent as SmallBannerNonEditable,
} from './organisms/MerchandisingSmallBanner';
import { MerchandisingTileSkinny as TileSkinny } from './organisms/MerchandisingTileSkinny';
import { MerchandisingCardTile as CardTile } from './organisms/MerchandisingCardTile';
import {
  MerchandisingSerpBanner as Serpbanner,
  MerchandisingSerpBannerComponent as SerpbannerNonEditable,
} from './organisms/MerchandisingSerpBanner';

export const MerchandisingHeroBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={HeroBanner} props={props} />;
};

export const MerchandisingSmallBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBanner} props={props} />;
};

export const MerchandisingSmallBannerNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBannerNonEditable} props={props} />;
};

export const MerchandisingTileSkinny = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={TileSkinny} props={props} />;
};

export const MerchandisingCardTile = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={CardTile} props={props} />;
};

export const MerchandisingSerpBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={Serpbanner} props={props} />;
};

export const MerchandisingSerpBannerNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SerpbannerNonEditable} props={props} />;
};
